module.exports = __webpack_public_path__ + "fonts/ChivasLoud_Bd.b33a208c.ttf";